import React from 'react';

import { DEFAULT_ICON_PROPS, IIconProps } from './constants';

export const RadioOnIcon = ({ ariaLabel = 'radio on state', ...props }: IIconProps) => {
  const { size, width, height, title, ariaHidden, className } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={size || width}
      height={size || height}
      viewBox={`0 0 ${size || width} ${size || height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      {...props}
    >
      {title && <title>{title}</title>}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 2.60465C7.03495 2.60465 2.60465 7.03495 2.60465 12.5C2.60465 17.9651 7.03495 22.3953 12.5 22.3953C17.9651 22.3953 22.3953 17.9651 22.3953 12.5C22.3953 7.03495 17.9651 2.60465 12.5 2.60465ZM1 12.5C1 6.14873 6.14873 1 12.5 1C18.8513 1 24 6.14873 24 12.5C24 18.8513 18.8513 24 12.5 24C6.14873 24 1 18.8513 1 12.5Z"
        fill="#061D33"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 19C8.925 19 6 16.075 6 12.5C6 8.925 8.925 6 12.5 6C16.075 6 19 8.925 19 12.5C19 16.075 16.075 19 12.5 19Z"
        fill="#061D33"
      />
    </svg>
  );
};
